import { render, staticRenderFns } from "./BiddingInput.vue?vue&type=template&id=774fc630&scoped=true"
import script from "./BiddingInput.vue?vue&type=script&lang=js"
export * from "./BiddingInput.vue?vue&type=script&lang=js"
import style0 from "./BiddingInput.vue?vue&type=style&index=0&id=774fc630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774fc630",
  null
  
)

export default component.exports